import { useGlobals } from 'hooks/useGlobals';
import { useIsSkincare } from 'hooks/useIsSkincare';
import { BENEFITS, SKINCARE_BENEFITS } from 'lib/constants/routes';
import { SciencePageId } from 'types/cms/science/SciencePageId';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface BenefitsProps {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

const title = 'Benefits';

export function Benefits({ onNavigate }: BenefitsProps) {
  const isSkincare = useIsSkincare();
  const { data: globals } = useGlobals();
  const path = isSkincare ? SKINCARE_BENEFITS : BENEFITS;

  const navigationCards = globals?.siteSettings.scienceNav?.navigationCards;
  const benefitsCard = navigationCards?.find(
    (card) =>
      card.link._id ===
      (isSkincare ? SciencePageId.BENEFITS_SKINCARE : SciencePageId.BENEFITS),
  );

  return (
    <ResultLayout
      href={path}
      title={title}
      image={benefitsCard?.image}
      onNavigate={() => onNavigate({ title, path })}
      type="Science"
    />
  );
}
